import { render, staticRenderFns } from "./Mensagem.vue?vue&type=template&id=30e84b69&scoped=true&"
import script from "./Mensagem.vue?vue&type=script&lang=js&"
export * from "./Mensagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e84b69",
  null
  
)

export default component.exports